import { IconNew, pincodeValidation, required } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { notRequired, optionalPincodeValidation } from '@jfs/ui-new/src/utils/validations'
import { Dropdown } from '../../../../components/Dropdown'
import { AadhaarAwareTextInput } from '../comps/AadhaarAwareTextInput'
import { DatePickerWithInfoIcon } from '../comps/DatePickerWithInfoIcon'
import { DropdownWithInfo } from '../comps/DropdownWithInfo'
import { Pincode } from '../comps/Pincode'
import { TextInputWithInfo } from '../comps/TextInputWithInfo'
import { UploadEntityFile } from '../comps/UploadEntityFile'
import { getDropdownData } from './dropdownData'
import { styles } from './styles'
import { addressValidation, hideNonExistantFields, Name, optionalAddressValidation } from './validations'

export const authorizedSignatoryForm = (dropDownData: any, editable: boolean, isStoreMerchant: boolean) => ({
  key: 'AUTHORIZED_SIGNATORY_FORM',
  verticalFlex: 1,
  horizontalFlex: 1,
  contentOverflow: 'auto',
  contentPadding: 24,
  title: 'Authorized Signatory',
  formItems: [
    {
      horizontalComps: [
        {
          fieldName: 'authSignatoryFirstName',
          ComponentName: TextInputWithInfo,
          ...styles.textinputStyle(editable),
          label: 'First Name',
          placeholder: 'First name',
          validationSchema: isStoreMerchant ? notRequired : Name,
          testID: 'authSignatoryFirstName',
        },
        {
          fieldName: 'authSignatoryLastName',
          ComponentName: TextInputWithInfo,
          ...styles.textinputStyle(editable),
          label: 'Last Name',
          placeholder: 'Last name',
          validationSchema: isStoreMerchant ? notRequired : Name,
          testID: 'authSignatoryLastName',
        },
      ],
    },
    {
      horizontalComps: [
        {
          fieldName: 'authSignatoryDateOfBirth',
          ComponentName: DatePickerWithInfoIcon,
          label: 'Date of Birth',
          placeholder: '',
          maxDate: new Date().setDate(new Date().getDate() - 365 * 18),
          minDate: new Date().setDate(new Date().getDate() - 365 * 120),
          validationSchema: isStoreMerchant ? notRequired : required,
          ...styles.datePickerStyle(editable),
          rightComponent: editable ? <IconNew id="CALENDAR" color={'PRIMARY'} /> : null,
          testID: 'authSignatoryDateOfBirth',
        },
        {
          fieldName: 'authSignatoryGender',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          label: 'Gender',
          title: 'Select your gender',
          validationSchema: isStoreMerchant ? notRequired : required,
          data: getDropdownData(dropDownData?.lovData, 'Gender'),
          dataFieldToRead: 'description',
          testID: 'authSignatoryGender',
        },
      ],
      horizontalSpacing: 2,
    },
    {
      fieldName: 'authSignatoryPoi',
      ComponentName: UploadEntityFile,
      isOptional: isStoreMerchant,
      uploadButtonTitle: 'Upload Supporting POI Documents',
      uploadDialogTitle: 'Upload Required Doc',
      nonEditableTitle: 'Uploaded POI Documents',
      jdmsTableColumns: ['Document Category', 'Document Number', 'Date of Expiry', 'Action'],
      hideColumnsJdms: ['kycDocuments', 'documentCategory', 'MERCHANT_DOCUMENT_TYPE'],
      optionalFields: [
        {
          key: 'authSignatoryPoiExpiryDate',
          exceptions: [{ key: 'authSignatoryPoiType', values: ['FS0002', 'IBS002'] }],
        },
      ],
      uploadId: dropDownData?.uploadId,
      editable,
      documentListHeaderMapper: [
        {
          key: 'NAME',
          header: 'File Name',
        },
        {
          key: 'MERCHANT_DOCUMENT_NAME',
          header: 'Doc Type',
        },
        {
          key: 'expiry',
          header: 'Expiry Date',
        },
        {
          key: 'documentNumber',
          header: 'Doc Id',
        },
        {
          key: '',
          header: '',
        },
      ],
      documentCategoriesSupported: ['POI'],
      uploadFileReqMapper: {
        documentName: 'authSignatoryPoiType',
        documentNumber: 'authSignatoryPoiId',
        dateOfExpiry: 'authSignatoryPoiExpiryDate',
        documentType: 'authSignatoryPoiType',
      },
      uploadFileReqConstants: {
        documentCategory: 'POI',
        uploadType: 'ENTITY',
      },
      categoryFieldName: 'authSignatoryPoiType',
      rowData: [
        {
          fieldName: 'authSignatoryPoiType',
          ComponentName: Dropdown,
          ...styles.dropDownStyle(editable),
          label: 'POI Type',
          title: 'Select document type',
          data: dropDownData?.poiData,
          testID: 'authSignatoryPoiType',
        },
        {
          fieldName: 'authSignatoryPoiId',
          ComponentName: AadhaarAwareTextInput,
          docTypeFieldName: 'authSignatoryPoiType',
          ...styles.textinputStyle(editable),
          label: 'POI ID',
          validationSchema: required,
          placeholder: 'Document Id',
          testID: 'authSignatoryPoiId',
        },
        {
          fieldName: 'authSignatoryPoiExpiryDate',
          ComponentName: DatePickerWithInfoIcon,
          label: 'POI Expiry Date',
          placeholder: '',
          minDate: new Date(),
          maxDate: new Date().setDate(new Date().getDate() + 365 * 100),
          rightComponent: <Icon id="CALENDAR" color={'PRIMARY'} />,
          ...styles.datePickerStyle(editable),
        },
      ],
      testID: 'authSignatoryPoi',
    },
    {
      fieldName: 'authSignatoryPoA',
      ComponentName: UploadEntityFile,
      isOptional: isStoreMerchant,
      uploadButtonTitle: 'Upload Supporting POA Documents',
      uploadDialogTitle: 'Upload Required Doc',
      nonEditableTitle: 'Uploaded POA Documents',
      optionalFields: [
        {
          key: 'authSignatoryPoaExpiryDate',
          exceptions: [{ key: 'authSignatoryPoaType', values: ['FS0002', 'IBS002'] }],
        },
      ],
      jdmsTableColumns: ['Document Category', 'Document Number', 'Date of Expiry', 'Action'],
      hideColumnsJdms: ['kycDocuments', 'documentCategory', 'MERCHANT_DOCUMENT_TYPE'],
      uploadId: dropDownData?.uploadId,
      editable,
      documentListHeaderMapper: [
        {
          key: 'NAME',
          header: 'File Name',
        },
        {
          key: 'MERCHANT_DOCUMENT_NAME',
          header: 'Doc Type',
        },
        {
          key: 'expiry',
          header: 'Expiry Date',
        },
        {
          key: 'documentNumber',
          header: 'Doc Id',
        },
        {
          key: '',
          header: '',
        },
      ],
      uploadFileReqMapper: {
        documentName: 'authSignatoryPoaType',
        documentNumber: 'authSignatoryPoaId',
        dateOfExpiry: 'authSignatoryPoaExpiryDate',
        documentType: 'authSignatoryPoaType',
      },
      uploadFileReqConstants: {
        documentCategory: 'POA',
        uploadType: 'ENTITY',
      },
      documentCategoriesSupported: ['POA'],
      categoryFieldName: 'authSignatoryPoaType',
      rowData: [
        {
          fieldName: 'authSignatoryPoaType',
          ComponentName: Dropdown,
          validationSchema: required,
          label: 'POA Type',
          title: 'Select document type',
          data: dropDownData?.poaData,
          minHeight: 32,
          fullWidthContent: true,
          labelType: 'label',
          testID: 'authSignatoryPoaType',
        },
        {
          fieldName: 'authSignatoryPoaId',
          ComponentName: AadhaarAwareTextInput,
          docTypeFieldName: 'authSignatoryPoaType',
          label: 'POA ID',
          placeholder: 'Document Id',
          validationSchema: required,
          ...styles.textinputStyle(editable),
          testID: 'authSignatoryPoaId',
        },
        {
          fieldName: 'authSignatoryPoaExpiryDate',
          ComponentName: DatePickerWithInfoIcon,
          label: 'POA Expiry Date',
          placeholder: '',
          showYearDropdown: true,
          scrollableYearDropdown: true,
          minDate: new Date(),
          maxDate: new Date().setDate(new Date().getDate() + 365 * 100),
          rightComponent: <Icon id="CALENDAR" color={'PRIMARY'} />,
          validationSchema: required,
          color: 'BLACK_21',
          labelFontSize: 12,
          paddingVertical: 3,
          labelPaddingBottom: 8,
          shouldCloseOnSelect: true,
          labelFontFamily: 'jiotype-medium',
          testID: 'authSignatoryPoaExpiryDate',
        },
      ],
    },
    {
      horizontalComps: [
        {
          fieldName: 'authSignatoryAddressLine1',
          ComponentName: TextInputWithInfo,
          label: 'Address Line 1',
          placeholder: 'Building, Street Name',
          validationSchema: isStoreMerchant ? optionalAddressValidation : addressValidation,
          ...styles.textinputStyle(editable),
          testID: 'authSignatoryAddressLine1',
        },
        {
          fieldName: 'authSignatoryAddressLine2',
          ComponentName: TextInputWithInfo,
          label: 'Address Line 2',
          placeholder: 'Locality',
          editable,
          validationSchema: isStoreMerchant ? optionalAddressValidation : addressValidation,
          ...styles.textinputStyle(editable),
          testID: 'authSignatoryAddressLine2',
        },
        {
          fieldName: 'authSignatoryPincode',
          ComponentName: Pincode,
          label: 'Pincode',
          placeholder: 'Pincode',
          validationSchema: isStoreMerchant ? optionalPincodeValidation : pincodeValidation,
          ...styles.textinputStyle(editable),
          testID: 'authSignatoryPincode',
          cityField: 'authSignatoryCity',
          stateField: 'authSignatoryState',
        },
      ],
      horizontalSpacing: 8,
    },
    {
      horizontalComps: [
        {
          fieldName: 'authSignatoryCity',
          ComponentName: TextInputWithInfo,
          validationSchema: isStoreMerchant ? notRequired : required,
          hideComponent: hideNonExistantFields('authSignatoryCity'),
          label: 'City',
          placeholder: 'Select City',
          ...styles.textinputStyle(false),
          testID: 'authSignatoryCity',
        },
        {
          fieldName: 'authSignatoryState',
          ComponentName: DropdownWithInfo,
          validationSchema: isStoreMerchant ? notRequired : required,
          label: 'State',
          title: 'Select State',
          hideComponent: hideNonExistantFields('authSignatoryState'),
          data: getDropdownData(dropDownData?.lovData, 'State'),
          dataFieldToRead: 'description',
          ...styles.dropDownStyle(false),
          testID: 'authSignatoryState',
        },
      ],
      horizontalSpacing: 8,
    },
  ],
  onSubmit: async (values) => {},
})
